import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import {
  UpdateProjectBuyingHouseDocument,
  ProjectPlanDocument,
  type UpdateProjectBuyingHouseInput,
} from 'graphql/generated/graphql';
import { toGraphqlError, withRaw } from 'utils/error';
import requireValue from 'utils/requireValue';

const useUpdateProjectBuyingHouseMutation = () => {
  const [updateProjectBuyingHouseMutation] = useMutation(UpdateProjectBuyingHouseDocument);

  const mutate = useCallback(
    async (projectId: string, formData: UpdateProjectBuyingHouseInput) => {
      try {
        const res = await updateProjectBuyingHouseMutation({
          variables: { projectId, formData: { ...formData } },
          refetchQueries: [{ query: ProjectPlanDocument, variables: { projectId } }],
          awaitRefetchQueries: true,
        });
        const { updateProjectBuyingHouse: result } = requireValue(
          res.data,
          'updateProjectBuyingHouse',
        );

        return result;
      } catch (error) {
        throw withRaw(toGraphqlError(error), error || '');
      }
    },
    [updateProjectBuyingHouseMutation],
  );
  return mutate;
};

export default useUpdateProjectBuyingHouseMutation;
